// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================================
   pi-swipe — Before / After image comparison
   Standalone component stylesheet. No dependencies.
   Everything is scoped under .pi-swipe. Ported verbatim from the
   PublicInput Frontend Public Design System handoff (Feature #9271).

   Runtime custom properties (set by swipe-comparison.js from
   data-* attributes; all have sane no-JS defaults):
     --pi-swipe-pos        divider position, 0–100 (unitless)
     --pi-swipe-before-x/y before-image focal point (object-position)
     --pi-swipe-after-x/y  after-image  focal point (object-position)
   ============================================================= */

.pi-swipe {
  --pi-swipe-pos: 50;
  --pi-swipe-before-x: 50%;
  --pi-swipe-before-y: 50%;
  --pi-swipe-after-x: 50%;
  --pi-swipe-after-y: 50%;
  --pi-swipe-line: #fff;
  --pi-swipe-grip-fg: #0a66c2;
  --pi-swipe-focus: #0a66c2;

  display: block;
  margin: 0;
  font-family: inherit;
}

/* ---- Empty-state placeholder (editor, before both images set) --- */
.pi-swipe__placeholder {
  padding: 40px;
  text-align: center;
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  color: #6c757d;
}

.pi-swipe__placeholder-icon {
  color: #6c757d;
}

/* ---- Caption / title (author text, server-escaped) ---------- */
.pi-swipe__caption {
  margin: 0 0 10px;
  font-size: 0.95rem;
  line-height: 1.45;
  color: #2c3137;
}

/* ---- Stage -------------------------------------------------- */
.pi-swipe__stage {
  position: relative;
  width: 100%;
  background: #0b1622; /* shows only as letterbox bars in fit-contain mode */
  border-radius: 8px;
  overflow: hidden;
}

/* Frame shape. Default 16:9; author picks another via a modifier
   class, or JS sets stage.style.aspectRatio from data-pi-swipe-ratio.
   A fixed frame is what lets two differently-sized images line up. */
.pi-swipe--ready .pi-swipe__stage {
  aspect-ratio: 16 / 9;
}

.pi-swipe--4x3.pi-swipe--ready .pi-swipe__stage {
  aspect-ratio: 4 / 3;
}

.pi-swipe--3x2.pi-swipe--ready .pi-swipe__stage {
  aspect-ratio: 3 / 2;
}

.pi-swipe--1x1.pi-swipe--ready .pi-swipe__stage {
  aspect-ratio: 1 / 1;
}

/* ---- Panes + images ----------------------------------------- */
.pi-swipe__pane {
  position: relative;
}

.pi-swipe__img {
  display: block;
  width: 100%;
  height: auto; /* no-JS: natural size, images stack */
}

/* Enhanced: both panes fill the same frame and each image is
   cover-cropped around its own focal point. This is how mismatched
   sizes/shapes are reconciled without a broken overlay. */
.pi-swipe--ready .pi-swipe__pane {
  position: absolute;
  inset: 0;
}

.pi-swipe--ready .pi-swipe__img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}

.pi-swipe--ready .pi-swipe__pane--after .pi-swipe__img {
  -o-object-position: var(--pi-swipe-after-x) var(--pi-swipe-after-y);
     object-position: var(--pi-swipe-after-x) var(--pi-swipe-after-y);
}

.pi-swipe--ready .pi-swipe__pane--before .pi-swipe__img {
  -o-object-position: var(--pi-swipe-before-x) var(--pi-swipe-before-y);
     object-position: var(--pi-swipe-before-x) var(--pi-swipe-before-y);
}

/* "Fit whole image" alternative — letterbox instead of crop. */
.pi-swipe--fit-contain.pi-swipe--ready .pi-swipe__img {
  -o-object-fit: contain;
     object-fit: contain;
}

/* After = base layer (left of divider). Before = overlay clipped to
   the right of the divider. value = % of the after image shown. */
.pi-swipe--ready .pi-swipe__pane--after {
  z-index: 1;
}

.pi-swipe--ready .pi-swipe__pane--before {
  z-index: 2;
  clip-path: inset(0 0 0 calc(var(--pi-swipe-pos) * 1%));
  transition: clip-path 90ms ease-out;
}

/* ---- Corner labels (author text) ---------------------------- */
.pi-swipe__label {
  position: absolute;
  top: 12px;
  z-index: 3;
  max-width: 45%;
  padding: 5px 11px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #fff;
  border-radius: 999px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);
}

.pi-swipe__label--after {
  left: 12px;
  background: rgba(10, 102, 194, 0.92);
}

.pi-swipe__label--before {
  right: 12px;
  background: rgba(43, 43, 43, 0.86);
}

.pi-swipe__label:empty {
  display: none;
}

/* ---- Divider + grip (decorative; the range does the work) --- */
.pi-swipe__divider {
  position: absolute;
  top: 0;
  bottom: 0;
  left: calc(var(--pi-swipe-pos) * 1%);
  z-index: 6;
  width: 2px;
  margin-left: -1px;
  background: var(--pi-swipe-line);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);
  pointer-events: none; /* let the range receive drags */
  transition: left 90ms ease-out;
}

.pi-swipe__grip {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 44px;
  height: 44px;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1px;
  background: var(--pi-swipe-line);
  color: var(--pi-swipe-grip-fg);
  border-radius: 50%;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.32);
}

.pi-swipe__grip svg {
  display: block;
  width: 14px;
  height: 14px;
}

/* ---- Range = the actual control (transparent, fills stage) -- */
.pi-swipe__range {
  position: absolute;
  inset: 0;
  z-index: 5;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  background: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
  cursor: ew-resize;
}

.pi-swipe__range:focus {
  outline: none;
}

.pi-swipe__range::-webkit-slider-runnable-track {
  height: 100%;
  background: transparent;
}

.pi-swipe__range::-moz-range-track {
  height: 100%;
  background: transparent;
}

.pi-swipe__range::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 44px;
  height: 100%;
  background: transparent;
  border: 0;
  cursor: ew-resize;
}

.pi-swipe__range::-moz-range-thumb {
  width: 44px;
  height: 100%;
  background: transparent;
  border: 0;
  cursor: ew-resize;
}

/* Keyboard focus ring — drawn on the grip, not the invisible input.
   The baseline :focus rule guarantees a visible indicator even on engines
   without :focus-visible support (WCAG 2.4.7); :focus-visible refines it. */
.pi-swipe__range:focus ~ .pi-swipe__divider .pi-swipe__grip {
  box-shadow: 0 0 0 3px rgba(10, 102, 194, 0.5), 0 3px 12px rgba(0, 0, 0, 0.32);
}

.pi-swipe__range:focus-visible ~ .pi-swipe__divider .pi-swipe__grip {
  box-shadow: 0 0 0 4px rgba(10, 102, 194, 0.45), 0 3px 12px rgba(0, 0, 0, 0.32);
}

/* ---- Progressive enhancement -------------------------------- */

/* Before JS runs (no .pi-swipe--ready): images stack, each with its
   label; the range and divider are hidden. Never a broken overlay. */
.pi-swipe__range,
.pi-swipe__divider {
  display: none;
}

.pi-swipe--ready .pi-swipe__range,
.pi-swipe--ready .pi-swipe__divider {
  display: block;
}

.pi-swipe:not(.pi-swipe--ready) .pi-swipe__pane + .pi-swipe__pane {
  margin-top: 4px;
}

/* ---- Puck editor preview (inert) ----------------------------- */

/* In the admin editor the widget renders without its range input and
   must never intercept the editor's click-to-select or drag sensors. */
.pi-swipe--editor .pi-swipe__stage * {
  pointer-events: none;
}

/* ---- Reduced motion ----------------------------------------- */
@media (prefers-reduced-motion: reduce) {
  .pi-swipe--ready .pi-swipe__pane--before,
  .pi-swipe__divider {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./Content/swipe-comparison.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;kEAWkE;;AAElE;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,2BAA2B;EAC3B,yBAAyB;;EAEzB,cAAc;EACd,SAAS;EACT,oBAAoB;AACtB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB,EAAE,qDAAqD;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;qEAEqE;AACrE;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY,EAAE,sCAAsC;AACtD;;AAEA;;0DAE0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA;EACE,mEAAgE;KAAhE,gEAAgE;AAClE;;AAEA;EACE,qEAAkE;KAAlE,kEAAkE;AACpE;;AAEA,+DAA+D;AAC/D;EACE,sBAAmB;KAAnB,mBAAmB;AACrB;;AAEA;kEACkE;AAClE;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,sDAAsD;EACtD,mCAAmC;AACrC;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,oCAAoC;EACpC,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,gCAAgC;EAChC,yCAAyC;EACzC,oBAAoB,EAAE,gCAAgC;EACtD,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gCAAgC;EAChC,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,wBAAwB;EACxB,qBAAgB;OAAhB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;4EAE4E;AAC5E;EACE,6EAA6E;AAC/E;;AAEA;EACE,8EAA8E;AAChF;;AAEA,kEAAkE;;AAElE;qEACqE;AACrE;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA,mEAAmE;;AAEnE;uEACuE;AACvE;EACE,oBAAoB;AACtB;;AAEA,kEAAkE;AAClE;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/* =============================================================\r\n   pi-swipe — Before / After image comparison\r\n   Standalone component stylesheet. No dependencies.\r\n   Everything is scoped under .pi-swipe. Ported verbatim from the\r\n   PublicInput Frontend Public Design System handoff (Feature #9271).\r\n\r\n   Runtime custom properties (set by swipe-comparison.js from\r\n   data-* attributes; all have sane no-JS defaults):\r\n     --pi-swipe-pos        divider position, 0–100 (unitless)\r\n     --pi-swipe-before-x/y before-image focal point (object-position)\r\n     --pi-swipe-after-x/y  after-image  focal point (object-position)\r\n   ============================================================= */\r\n\r\n.pi-swipe {\r\n  --pi-swipe-pos: 50;\r\n  --pi-swipe-before-x: 50%;\r\n  --pi-swipe-before-y: 50%;\r\n  --pi-swipe-after-x: 50%;\r\n  --pi-swipe-after-y: 50%;\r\n  --pi-swipe-line: #fff;\r\n  --pi-swipe-grip-fg: #0a66c2;\r\n  --pi-swipe-focus: #0a66c2;\r\n\r\n  display: block;\r\n  margin: 0;\r\n  font-family: inherit;\r\n}\r\n\r\n/* ---- Empty-state placeholder (editor, before both images set) --- */\r\n.pi-swipe__placeholder {\r\n  padding: 40px;\r\n  text-align: center;\r\n  background: #f8f9fa;\r\n  border: 2px dashed #dee2e6;\r\n  border-radius: 8px;\r\n  color: #6c757d;\r\n}\r\n\r\n.pi-swipe__placeholder-icon {\r\n  color: #6c757d;\r\n}\r\n\r\n/* ---- Caption / title (author text, server-escaped) ---------- */\r\n.pi-swipe__caption {\r\n  margin: 0 0 10px;\r\n  font-size: 0.95rem;\r\n  line-height: 1.45;\r\n  color: #2c3137;\r\n}\r\n\r\n/* ---- Stage -------------------------------------------------- */\r\n.pi-swipe__stage {\r\n  position: relative;\r\n  width: 100%;\r\n  background: #0b1622; /* shows only as letterbox bars in fit-contain mode */\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Frame shape. Default 16:9; author picks another via a modifier\r\n   class, or JS sets stage.style.aspectRatio from data-pi-swipe-ratio.\r\n   A fixed frame is what lets two differently-sized images line up. */\r\n.pi-swipe--ready .pi-swipe__stage {\r\n  aspect-ratio: 16 / 9;\r\n}\r\n\r\n.pi-swipe--4x3.pi-swipe--ready .pi-swipe__stage {\r\n  aspect-ratio: 4 / 3;\r\n}\r\n\r\n.pi-swipe--3x2.pi-swipe--ready .pi-swipe__stage {\r\n  aspect-ratio: 3 / 2;\r\n}\r\n\r\n.pi-swipe--1x1.pi-swipe--ready .pi-swipe__stage {\r\n  aspect-ratio: 1 / 1;\r\n}\r\n\r\n/* ---- Panes + images ----------------------------------------- */\r\n.pi-swipe__pane {\r\n  position: relative;\r\n}\r\n\r\n.pi-swipe__img {\r\n  display: block;\r\n  width: 100%;\r\n  height: auto; /* no-JS: natural size, images stack */\r\n}\r\n\r\n/* Enhanced: both panes fill the same frame and each image is\r\n   cover-cropped around its own focal point. This is how mismatched\r\n   sizes/shapes are reconciled without a broken overlay. */\r\n.pi-swipe--ready .pi-swipe__pane {\r\n  position: absolute;\r\n  inset: 0;\r\n}\r\n\r\n.pi-swipe--ready .pi-swipe__img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n.pi-swipe--ready .pi-swipe__pane--after .pi-swipe__img {\r\n  object-position: var(--pi-swipe-after-x) var(--pi-swipe-after-y);\r\n}\r\n\r\n.pi-swipe--ready .pi-swipe__pane--before .pi-swipe__img {\r\n  object-position: var(--pi-swipe-before-x) var(--pi-swipe-before-y);\r\n}\r\n\r\n/* \"Fit whole image\" alternative — letterbox instead of crop. */\r\n.pi-swipe--fit-contain.pi-swipe--ready .pi-swipe__img {\r\n  object-fit: contain;\r\n}\r\n\r\n/* After = base layer (left of divider). Before = overlay clipped to\r\n   the right of the divider. value = % of the after image shown. */\r\n.pi-swipe--ready .pi-swipe__pane--after {\r\n  z-index: 1;\r\n}\r\n\r\n.pi-swipe--ready .pi-swipe__pane--before {\r\n  z-index: 2;\r\n  clip-path: inset(0 0 0 calc(var(--pi-swipe-pos) * 1%));\r\n  transition: clip-path 90ms ease-out;\r\n}\r\n\r\n/* ---- Corner labels (author text) ---------------------------- */\r\n.pi-swipe__label {\r\n  position: absolute;\r\n  top: 12px;\r\n  z-index: 3;\r\n  max-width: 45%;\r\n  padding: 5px 11px;\r\n  font-size: 0.72rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n  color: #fff;\r\n  border-radius: 999px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28);\r\n}\r\n\r\n.pi-swipe__label--after {\r\n  left: 12px;\r\n  background: rgba(10, 102, 194, 0.92);\r\n}\r\n\r\n.pi-swipe__label--before {\r\n  right: 12px;\r\n  background: rgba(43, 43, 43, 0.86);\r\n}\r\n\r\n.pi-swipe__label:empty {\r\n  display: none;\r\n}\r\n\r\n/* ---- Divider + grip (decorative; the range does the work) --- */\r\n.pi-swipe__divider {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: calc(var(--pi-swipe-pos) * 1%);\r\n  z-index: 6;\r\n  width: 2px;\r\n  margin-left: -1px;\r\n  background: var(--pi-swipe-line);\r\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.12);\r\n  pointer-events: none; /* let the range receive drags */\r\n  transition: left 90ms ease-out;\r\n}\r\n\r\n.pi-swipe__grip {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 44px;\r\n  height: 44px;\r\n  transform: translate(-50%, -50%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 1px;\r\n  background: var(--pi-swipe-line);\r\n  color: var(--pi-swipe-grip-fg);\r\n  border-radius: 50%;\r\n  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.32);\r\n}\r\n\r\n.pi-swipe__grip svg {\r\n  display: block;\r\n  width: 14px;\r\n  height: 14px;\r\n}\r\n\r\n/* ---- Range = the actual control (transparent, fills stage) -- */\r\n.pi-swipe__range {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 5;\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  background: transparent;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  cursor: ew-resize;\r\n}\r\n\r\n.pi-swipe__range:focus {\r\n  outline: none;\r\n}\r\n\r\n.pi-swipe__range::-webkit-slider-runnable-track {\r\n  height: 100%;\r\n  background: transparent;\r\n}\r\n\r\n.pi-swipe__range::-moz-range-track {\r\n  height: 100%;\r\n  background: transparent;\r\n}\r\n\r\n.pi-swipe__range::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 44px;\r\n  height: 100%;\r\n  background: transparent;\r\n  border: 0;\r\n  cursor: ew-resize;\r\n}\r\n\r\n.pi-swipe__range::-moz-range-thumb {\r\n  width: 44px;\r\n  height: 100%;\r\n  background: transparent;\r\n  border: 0;\r\n  cursor: ew-resize;\r\n}\r\n\r\n/* Keyboard focus ring — drawn on the grip, not the invisible input.\r\n   The baseline :focus rule guarantees a visible indicator even on engines\r\n   without :focus-visible support (WCAG 2.4.7); :focus-visible refines it. */\r\n.pi-swipe__range:focus ~ .pi-swipe__divider .pi-swipe__grip {\r\n  box-shadow: 0 0 0 3px rgba(10, 102, 194, 0.5), 0 3px 12px rgba(0, 0, 0, 0.32);\r\n}\r\n\r\n.pi-swipe__range:focus-visible ~ .pi-swipe__divider .pi-swipe__grip {\r\n  box-shadow: 0 0 0 4px rgba(10, 102, 194, 0.45), 0 3px 12px rgba(0, 0, 0, 0.32);\r\n}\r\n\r\n/* ---- Progressive enhancement -------------------------------- */\r\n\r\n/* Before JS runs (no .pi-swipe--ready): images stack, each with its\r\n   label; the range and divider are hidden. Never a broken overlay. */\r\n.pi-swipe__range,\r\n.pi-swipe__divider {\r\n  display: none;\r\n}\r\n\r\n.pi-swipe--ready .pi-swipe__range,\r\n.pi-swipe--ready .pi-swipe__divider {\r\n  display: block;\r\n}\r\n\r\n.pi-swipe:not(.pi-swipe--ready) .pi-swipe__pane + .pi-swipe__pane {\r\n  margin-top: 4px;\r\n}\r\n\r\n/* ---- Puck editor preview (inert) ----------------------------- */\r\n\r\n/* In the admin editor the widget renders without its range input and\r\n   must never intercept the editor's click-to-select or drag sensors. */\r\n.pi-swipe--editor .pi-swipe__stage * {\r\n  pointer-events: none;\r\n}\r\n\r\n/* ---- Reduced motion ----------------------------------------- */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .pi-swipe--ready .pi-swipe__pane--before,\r\n  .pi-swipe__divider {\r\n    transition: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
